import { render, staticRenderFns } from "./VehicleDamageAll.vue?vue&type=template&id=5be237c2&lang=pug&"
import script from "./VehicleDamageAll.vue?vue&type=script&lang=ts&"
export * from "./VehicleDamageAll.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleDamageAll.vue?vue&type=style&index=0&id=5be237c2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports